import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  height: 100%;\n  box-sizing: border-box;\n  position: relative;\n  padding: 0;\n  margin: 0;\n  flex-shrink: 0;\n  opacity: 1;\n  transition: opacity 0.2s ease-out;\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  box-sizing: border-box;\n  position: relative;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  list-style: none;\n  box-sizing: border-box;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  will-change: transform;\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      ", "\n      ", "\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      ", "\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 100%;\n  box-sizing: content-box;\n  position: relative;\n  z-index: 1;\n  transform: translateX(0); // Workaround for iOS safari bug\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { animated, useSpring } from 'react-spring';
import { EMPTY_PROPS, getPercent, getPx, isDefined, styleArrayForBreakpoints, styleForBreakpoints } from '../../../helpers';
import { Backdrop } from '../../../Backdrop';
import { $showMixin, heightMixin } from '../../../mixins/layout';
import { HOOKS_SWIPE_TOLERANCE } from '../../../constants';
import { useDebounce, useDeviceType, useIsClient } from '../../../hooks';
import { getItemIndex } from '../helpers';
import { justifyMap } from '../../../style/flex-justify';
import { marginHorizontalNegative, marginVerticalNegative, overflowHidden, paddingHalfHorizontal, paddingHorizontal, paddingVertical } from '../../../style';
var SliderWrapper = styled.div(_templateObject(), function (_ref) {
  var $withOverflowHidden = _ref.$withOverflowHidden;
  return overflowHidden($withOverflowHidden);
}, function (_ref2) {
  var value = _ref2.$overflowSpacingVertical;
  return isDefined(value) && css(_templateObject2(), paddingVertical(value), marginVerticalNegative(value));
}, function (_ref3) {
  var value = _ref3.$overflowSpacingHorizontal;
  return isDefined(value) && css(_templateObject3(), paddingHorizontal(value), marginHorizontalNegative(value));
}, heightMixin);
var SliderItemsWrapper = styled(animated.ul || animated.div)(_templateObject4(), function (_ref4) {
  var $alignX = _ref4.$alignX,
      $cards = _ref4.$cards,
      $children = _ref4.$children;
  return styleArrayForBreakpoints([$alignX, $cards], function (_ref5) {
    var $alignX = _ref5[0],
        $cards = _ref5[1];
    var alignX = $children < $cards ? $alignX : 'flex-start';
    return "justify-content: " + (justifyMap.get(alignX) || alignX) + ";";
  });
}, heightMixin);
var SliderItemContainer = styled.div(_templateObject5(), heightMixin);
var SliderItem = styled(animated.li || animated.div)(_templateObject6(), heightMixin, function (_ref6) {
  var $cards = _ref6.$cards,
      $children = _ref6.$children;
  return styleForBreakpoints($cards, function ($cards) {
    var amount = $children === 1 && $cards > 1 && $cards < 2 ? 1 : $cards;
    return "width: calc(100% / " + amount + ");";
  });
}, function (_ref7) {
  var $gutter = _ref7.$gutter;
  return paddingHalfHorizontal($gutter);
}, function (_ref8) {
  var $infinite = _ref8.$infinite,
      $index = _ref8.$index;
  return $infinite ? "\n        position: absolute;\n        top: 0;\n        left: 0;\n        transform: translateX(" + getPercent($index * 100) + ");\n      " : '';
});
var StyledBackdrop = styled(Backdrop)(_templateObject7(), $showMixin, function (_ref9) {
  var $disabled = _ref9.$disabled;
  return $disabled ? "display: none !important;" : '';
});
export var ItemsCarouselSlider = function ItemsCarouselSlider(_ref10) {
  var enabled = _ref10.enabled,
      items = _ref10.items,
      showBackdrop = _ref10.showBackdrop,
      minVisibleItemIndex = _ref10.minVisibleItemIndex,
      maxVisibleItemIndex = _ref10.maxVisibleItemIndex,
      _ref10$config = _ref10.config,
      config = _ref10$config === void 0 ? EMPTY_PROPS : _ref10$config,
      _ref10$fromTranslateX = _ref10.fromTranslateX,
      fromTranslateX = _ref10$fromTranslateX === void 0 ? 0 : _ref10$fromTranslateX,
      _ref10$toTranslateX = _ref10.toTranslateX,
      toTranslateX = _ref10$toTranslateX === void 0 ? 0 : _ref10$toTranslateX,
      _ref10$initialTransla = _ref10.initialTranslateX,
      initialTranslateX = _ref10$initialTransla === void 0 ? 0 : _ref10$initialTransla,
      minDisplayIndex = _ref10.minDisplayIndex,
      maxDisplayIndex = _ref10.maxDisplayIndex,
      id = _ref10.id,
      alignX = _ref10.alignX,
      height = _ref10.height,
      gutter = _ref10.gutter,
      numberOfCards = _ref10.numberOfCards,
      numberOfChildren = _ref10.numberOfChildren,
      withOverflowHidden = _ref10.withOverflowHidden,
      overflowSpacingVertical = _ref10.overflowSpacingVertical,
      overflowSpacingHorizontal = _ref10.overflowSpacingHorizontal,
      dotsBackdropHeight = _ref10.dotsBackdropHeight,
      isAutoplayEnabled = _ref10.isAutoplayEnabled,
      getItemLabel = _ref10.getItemLabel,
      getItemProps = _ref10.getItemProps,
      listProps = _ref10.listProps,
      disabled = _ref10.disabled,
      infinite = _ref10.infinite;

  var _useDeviceType = useDeviceType(),
      isServer = _useDeviceType.isServer;

  var _useIsClient = useIsClient("carousel-slider" + (id ? "-" + id : '')),
      key = _useIsClient.key;

  var springConfig = useMemo(function () {
    return _objectSpread({
      tension: 180,
      friction: 28
    }, config);
  }, [config]);
  var enabledDebounced = useDebounce(enabled); // @ts-expect-error `useSpring` types

  var _useSpring = useSpring({
    from: {
      translateX: fromTranslateX
    },
    to: {
      translateX: toTranslateX
    },
    config: springConfig,
    immediate: !enabledDebounced
  }),
      translateX = _useSpring.translateX;

  var itemsToRender = useMemo(function () {
    if (!infinite || isServer) {
      return items.map(function (item, index) {
        return {
          index: index,
          item: item
        };
      });
    }

    var indicesToDisplay = Array(maxDisplayIndex - minDisplayIndex + 1).fill(undefined).map(function (v, idx) {
      return idx + minDisplayIndex;
    });
    return indicesToDisplay.map(function (index) {
      return {
        index: index,
        item: items[getItemIndex(index, items.length)]
      };
    });
  }, [items, infinite, isServer, minDisplayIndex, maxDisplayIndex]);

  var _ref12 = /*#__PURE__*/React.createElement(StyledBackdrop, {
    $disabled: disabled,
    $show: showBackdrop,
    position: 'bottom',
    height: dotsBackdropHeight
  });

  return /*#__PURE__*/React.createElement(SliderWrapper, {
    key: infinite ? key : undefined,
    $height: height,
    $withOverflowHidden: withOverflowHidden,
    $overflowSpacingVertical: overflowSpacingVertical,
    $overflowSpacingHorizontal: overflowSpacingHorizontal
  }, /*#__PURE__*/React.createElement(SliderItemsWrapper, _extends({
    id: id,
    "aria-live": isAutoplayEnabled ? 'polite' : 'off',
    style: {
      transform: !enabled ? "translateX(" + getPx(-initialTranslateX) + ")" : translateX.interpolate(function (x) {
        return "translateX(" + getPx(-x) + ")";
      })
    },
    $height: height,
    $alignX: alignX,
    $cards: numberOfCards,
    $children: numberOfChildren
  }, listProps), itemsToRender.map(function (_ref11) {
    var item = _ref11.item,
        index = _ref11.index;
    var itemIndex = infinite ? getItemIndex(index, items.length) : index;
    return /*#__PURE__*/React.createElement(SliderItem, _extends({
      key: index,
      $height: height,
      $cards: numberOfCards,
      $children: numberOfChildren,
      $gutter: gutter,
      $infinite: infinite,
      $index: index,
      style: {
        opacity: translateX.interpolate(function (x) {
          return enabled ? overflowSpacingHorizontal > 0 && (itemIndex < minVisibleItemIndex || itemIndex > maxVisibleItemIndex) && Math.abs(x - fromTranslateX) <= HOOKS_SWIPE_TOLERANCE ? 0 : 1 : overflowSpacingHorizontal > 0 && (itemIndex < minVisibleItemIndex || itemIndex > maxVisibleItemIndex) ? 0 : 1;
        })
      }
    }, getItemProps(itemIndex, items.length)), /*#__PURE__*/React.createElement(SliderItemContainer, {
      role: "group",
      "aria-roledescription": "slide",
      "aria-label": getItemLabel(itemIndex, items.length),
      $height: height
    }, item, showBackdrop !== false && _ref12));
  })));
};